module.exports = __webpack_public_path__ + "img/book4.bf199076.png";